import Dropzone, {DropzoneProps} from 'react-dropzone'

interface FileDropProps extends DropzoneProps {
  templateLink: string
  templateFileName: string
  supportText?: string
}

function FileDrop({templateLink, templateFileName, supportText, ...dropZoneProps}: FileDropProps) {
  return (
    <div>
      <Dropzone
        multiple={false}
        accept={{
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
        }}
        {...dropZoneProps}
      >
        {({getRootProps, getInputProps}) => (
          <section>
            <div className="dropzone" {...getRootProps()}>
              <div className="dz-message needsclick flex-column text-center">
                <div className="w-100 ">
                  <i className="ki-duotone ki-file-up fs-3x text-primary">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                </div>

                <input {...getInputProps()} />

                <div className="ms-4">
                  <h3 className="fs-2 fw-light text-gray-900 my-2">
                    Drop an xlsx file here or click to upload.
                  </h3>
                </div>
              </div>
            </div>
          </section>
        )}
      </Dropzone>
      <div className="text-center mt-2">
        Download a sample template{' '}
        <a href={templateLink} download={templateFileName}>
          here
        </a>
      </div>
      {supportText && (
        <div className="text-center text-muted  mt-2">
          <span className="text-gray-800">Note:</span> {supportText}
        </div>
      )}
    </div>
  )
}

export default FileDrop
